<template>
  <div class="custom-date-range">
    <el-date-picker
      v-model="start"
      :type="type"
      :placeholder="startPlaceholder"
      :value-format="valueFormate"
      :pickerOptions="{ disabledDate: time => this.disDate(time, 'start') }"
      @change="changeHandler()"
      :size="size"
      class="start-picker">
    </el-date-picker>
    <span class="split-text">{{separator}}</span>
    <el-date-picker
      v-model="end"
      :type="type"
      :placeholder="endPlaceholder"
      :value-format="valueFormate"
      :pickerOptions="{ disabledDate: time => this.disDate(time, 'end') }"
      @change="changeHandler()"
      :size="size"
      class="end-picker"
      >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data () {
    return {
      start: null,
      end: null,
      isChange: false
    }
  },
  props: {
    value: Array | null,
    startPlaceholder: {
      type: String,
      default: '开始时间'
    },
    endPlaceholder: {
      type: String,
      default: '结束时间'
    },
    valueFormate: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    type: {
      validator: val => ['year', 'month', 'date'].indexOf(val) != -1,
      default: 'date'
    },
    separator: {
      type: String,
      default: '至'
    },
    size: String
  },
  watch: {
    value: {
      handler(val){
        if(val && Array.isArray(val)){
          let [ start, end ] = val;
          if(this.start != start) this.start = new Date(start) || null;
          if(this.end != end) this.end = new Date(end) || null;
        }else if(!this.isChange){
          this.start = null;
          this.end = null;
        }
      },
      immediate: true
    }
  },
  methods: {
    changeHandler(){
      this.isChange = true;
      if(this.start && this.end) 
        this.$emit('input', [this.start, this.end]);
      else
        this.$emit('input', null);
      this.$nextTick(() => {
        this.isChange = false;
        this.$emit('change', this.value);
        this.$parent.clearValidate && 
        this.$parent.clearValidate()
      });
    },
    disDate(time, type){
      switch(type){
        case 'start':
          return this.end && new Date(time) > new Date(this.end);
        case 'end':
          return this.start && new Date(time) < new Date(this.start);
        default:
          return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-date-range{
  .split-text{
    display: inline-block;
    width: 16px;
    font-size: 13px;
    color: $text2;
  }

  >>> .el-date-editor{
    width: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DateRange.vue